// @flow
import React from 'react';

import { HEALTH_ENTRY_ZIP_CODE_ENTER } from 'client/constants/amplitudeTracker';
import HealthHero from 'client/components/healthHero';

import { Tracking } from 'web-core/src/tracking';

const HomeHealthHeroContainer = (props: Object) => {
  const { herocontent, contentfuldata, siteconfigs } = props;
  // props passing from pug are string, parse them before passing to HealthHero
  const heroContent = JSON.parse(herocontent);
  const contentfulData = JSON.parse(contentfuldata);
  const siteConfigs = JSON.parse(siteconfigs);
  const heroImage = heroContent.backgroundImage;

  const handleClick = (value, sectionName) => {
    Tracking.track(HEALTH_ENTRY_ZIP_CODE_ENTER, { zipcode: value, section: sectionName });
  };

  return (
    <HealthHero
      contentfulData={contentfulData}
      heroImage={heroImage}
      onSearch={handleClick}
      notShowNav
      sectionName="Homepage Hero"
      siteConfigs={siteConfigs} />
  );
};

export default HomeHealthHeroContainer;
